import { MealPreferences } from "@/clients/models/MealPreferences";
import { MealTime } from "@/clients/models/MealTime";
import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetMealPreferences = (mealTime: MealTime) => {
  const { data, isLoading, error } = useQuery<MealPreferences>({
    queryKey: [QueryKeys.MEAL_PREFERENCES, mealTime],
    queryFn: async () => {
      if (mealTime === MealTime.SNACK) {
        return {
          weekdayChoices: [
            "Fruit",
            "Protein bars",
            "Cookies",
            "Yogurt",
            "Protein bars",
            "Crisps",
            "Yogurt",
            "Chocolate",
            "Crisps",
            "Ice cream",
          ],
          weekEndsChoices: [
            "Fruit",
            "Protein bars",
            "Cookies",
            "Yogurt",
            "Protein bars",
            "Crisps",
            "Yogurt",
            "Chocolate",
            "Crisps",
            "Ice cream",
          ],
        };
      }
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealPreferencesService.getMealPreferencesApiV1MealPreferencesMealTimeGet(
          mealTime,
          user.id,
        );
      return data as MealPreferences;
    },
  });
  return {
    mealPreferences: data,
    isLoading,
    error,
  };
};
